import { supabase } from '@/integrations/supabase/client'

export interface TeamMember {
  id: string
  name: string
  position: string
  description: string | null
  image_url: string | null
  hover_image_url: string | null
  email: string | null
  linkedin_url: string | null
  phone: string | null
  sort_order: number
  is_active: boolean
  created_at: string
  updated_at: string
}

export const getTeamMembers = async (): Promise<TeamMember[]> => {
  const { data, error } = await supabase
    .from('team_members')
    .select('*')
    .eq('is_active', true)
    .order('sort_order', { ascending: true })

  if (error) {
    console.error('Error fetching team members:', error)
    throw error
  }

  return data || []
}

export const getAllTeamMembers = async (): Promise<TeamMember[]> => {
  const { data, error } = await supabase
    .from('team_members')
    .select('*')
    .order('sort_order', { ascending: true })

  if (error) {
    console.error('Error fetching all team members:', error)
    throw error
  }

  return data || []
}

export const createTeamMember = async (member: Omit<TeamMember, 'id' | 'created_at' | 'updated_at'>): Promise<TeamMember> => {
  const { data, error } = await supabase
    .from('team_members')
    .insert([member])
    .select()
    .single()

  if (error) {
    console.error('Error creating team member:', error)
    throw error
  }

  return data
}

export const updateTeamMember = async (id: string, updates: Partial<Omit<TeamMember, 'id' | 'created_at' | 'updated_at'>>): Promise<TeamMember> => {
  const { data, error } = await supabase
    .from('team_members')
    .update(updates)
    .eq('id', id)
    .select()
    .single()

  if (error) {
    console.error('Error updating team member:', error)
    throw error
  }

  return data
}

export const deleteTeamMember = async (id: string): Promise<void> => {
  const { error } = await supabase
    .from('team_members')
    .delete()
    .eq('id', id)

  if (error) {
    console.error('Error deleting team member:', error)
    throw error
  }
}
